import apiClient from "../../utils/apiClient";
import apiService from "../apiService/apiService";

const GET_PROGRAMS = "/programs";
const GET_PROGRAM_BY_ID = "programs";

const getPrograms = () => {
    return apiClient.get(GET_PROGRAMS);
}

const getSpeakerPrograms = (page, searchTerm) => {
    const params = {
        'page': page,
        's': searchTerm,
    };

    const queryString = apiService.getRequestParams(params);
    let url = `speaker/programs${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
}

const getSingleProgramData = (id) => {
    const url = `${GET_PROGRAM_BY_ID}/${id}`;
    return apiClient.get(url);
};

const rateProgram = (id, rating) => {
    const data = {
        rating: rating
    };
    const url = `programs/${id}/rate`;

    return apiClient.post(url, data);
};

const createNextSteps = (programId, nextStepsText) => {
    const data = {
        text: nextStepsText
    };
    const url = `programs/${programId}/next-steps`;

    return apiClient.post(url, data);
};

const updateNextSteps = (programId, nextStepsText, nextStepId) => {
    const data = {
        text: nextStepsText
    };
    const url = `programs/${programId}/next-steps/${nextStepId}`;

    return apiClient.put(url, data);
};

const getProgramPreviewData = (id) => {
    const url = `programs/${id}/preview`;
    return apiClient.get(url);
};

const downloadCertificate = (id) => {
    const url = `programs/${id}/certificate`;
    return apiClient.get(url);
};

const getSpeakerSingleProgramData = (id) => {
    const url = `speaker/${GET_PROGRAM_BY_ID}/${id}`;
    return apiClient.get(url);
};

const getProgramCertificate = (id) => {
    const url = `programs/certificates/${id}`;
    return apiClient.get(url);
};

const shareOnLinkedin = (id, formData) => {
    const url = `programs/certificates/${id}/share-certificate`;
    return apiClient.post(url, formData);
};

const shareNextStepOnCommunity = (programId, nextStepId) => {
    const url = `programs/${programId}/next-steps/${nextStepId}/share-to-community`;
    return apiClient.post(url);
};

const shareNextStepOnLinkedin = (programId, nextStepId) => {
    const url = `programs/${programId}/next-steps/${nextStepId}/share-to-linkedin`;
    return apiClient.post(url);
};

const completeProgram = (id) => {
    const url = `programs/${id}/complete`;
    return apiClient.post(url);
};

export const programsService = {
    getPrograms,
    getSingleProgramData,
    rateProgram,
    createNextSteps,
    updateNextSteps,
    getProgramPreviewData,
    downloadCertificate,
    getSpeakerPrograms,
    getSpeakerSingleProgramData,
    getProgramCertificate,
    shareOnLinkedin,
    shareNextStepOnCommunity,
    shareNextStepOnLinkedin,
    completeProgram
}